<div
  id="dcpModal"
  tabindex="-1"
  role="dialog"
  class="modal fade modal-colored-header"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg">
    <div style="background-color: #009">
      <div class="panel-heading headering">
        <h1>Product Searcher</h1>
        <div *ngIf="canSimulateUserRole" class="simulate-user-role-toggle">
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="simulateUserRole" (change)="onSimulateUserRoleChange()">
            <span class="toggle-slider"></span>
            <span class="toggle-label">Simulate user role</span>
          </label>
        </div>
        <button #closeDcpModal type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
    </div>

    <div class="panel-body" style="background-color: white; color: black">
      <app-dcp-filter [dcpService]="dcpService" (filtersChanged)="onFiltersChanged()"></app-dcp-filter>

      <app-dcp-table
        (rowSelected)="onRowSelected($event)"
        (loadProduct)="onDoubleClickLoad($event)"
        [selectedProduct]="selectedProduct"
      ></app-dcp-table>
    </div>
    <div class="modal-footer" style="justify-content: flex-end;">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
      <button type="button" class="btn btn-primary" [disabled]="!selectedProduct" (click)="loadSelectedProduct()">Load</button>
    </div>
  </div>
</div>
